/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ApplicationEventTemplateVariable = {
    /**
     * Variable name as it should appear inside a `{{ ... }}` placeholder in a notification template.
     * Dot-separated paths are supported (for example "data.projectName").
     *
     */
    name: string;
    /**
     * Runtime type of the variable value
     */
    type: ApplicationEventTemplateVariable.type;
    /**
     * Human-readable description of the variable
     */
    description: string;
    /**
     * Sample value illustrating what the variable typically contains
     */
    example?: string;
};
export namespace ApplicationEventTemplateVariable {
    /**
     * Runtime type of the variable value
     */
    export enum type {
        STRING = 'string',
        NUMBER = 'number',
        BOOLEAN = 'boolean',
    }
}

